import script from "./RateIt.vue?vue&type=script&setup=true&lang=js"
export * from "./RateIt.vue?vue&type=script&setup=true&lang=js"

import "./RateIt.vue?vue&type=style&index=0&id=1e1c6cc5&scoped=true&lang=css"

import exportComponent from "/app/tmp/origina/V3/v2026.7.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e1c6cc5"]])

export default __exports__